import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import { SPORT_HUB_INFO, HUB_SECTIONS } from './SportHubScreen';
import BackButton from '../BackButton';

const SPORT_ORDER = ['nfl', 'nba', 'mlb', 'nhl', 'soccer', 'ncaaf', 'ncaab', 'wnba', 'ufc', 'boxing', 'tennis', 'golf'];

const sectionLabel = (s) => s.charAt(0).toUpperCase() + s.slice(1);

// Full-page version of the All Sports hover menu: every sport,
// with each of its sections under it.
const AllSportsScreen = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <BackButton />
      <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 700 }}>
        All Sports
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Every sport, every section. Choose a league, then open the exact section you need.
      </Typography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)', lg: 'repeat(4, 1fr)' },
          gap: 2,
        }}
      >
        {SPORT_ORDER.map((slug) => {
          const sport = SPORT_HUB_INFO[slug];
          return (
            <Box key={slug} sx={{ bgcolor: 'action.hover', p: 2, borderRadius: 1 }}>
              <Button
                onClick={() => navigate(`/sport/${slug}/overview`)}
                sx={{
                  justifyContent: 'flex-start',
                  width: '100%',
                  p: 0,
                  pb: 1,
                  mb: 1.25,
                  borderRadius: 0,
                  borderBottom: '2px solid #1d5c3f',
                  color: '#FFFFFF',
                  fontWeight: 800,
                  fontSize: '1.15rem',
                  textTransform: 'none',
                }}
              >
                {sport.display}
              </Button>
              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.5 }}>
                {HUB_SECTIONS.map((section) => (
                  <Button
                    key={section}
                    onClick={() => navigate(`/sport/${slug}/${section}`)}
                    sx={{
                      justifyContent: 'flex-start',
                      px: 0.75,
                      py: 0.85,
                      minWidth: 0,
                      color: '#FFFFFF',
                      fontSize: '0.72rem',
                      fontWeight: 700,
                      textTransform: 'none',
                    }}
                  >
                    {sectionLabel(section)}
                  </Button>
                ))}
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default AllSportsScreen;
